import AnchorWrapper from './AnchorWrapper';

export default AnchorWrapper;
